<template>
  <svg
    :class="size"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_355_6008)">
      <path
        d="M16.0727 32.1445C24.7855 32.1445 31.8486 25.0814 31.8486 16.3686C31.8486 7.65587 24.7855 0.592773 16.0727 0.592773C7.35997 0.592773 0.296875 7.65587 0.296875 16.3686C0.296875 25.0814 7.35997 32.1445 16.0727 32.1445Z"
        fill="#627EEA"
      />
      <path
        d="M16.5635 4.53662V13.2824L23.9555 16.5854L16.5635 4.53662Z"
        fill="white"
        fill-opacity="0.602"
      />
      <path
        d="M16.5639 4.53662L9.1709 16.5854L16.5639 13.2824V4.53662Z"
        fill="white"
      />
      <path
        d="M16.5635 22.253V28.1955L23.9604 17.9619L16.5635 22.253Z"
        fill="white"
        fill-opacity="0.602"
      />
      <path
        d="M16.5639 28.1955V22.252L9.1709 17.9619L16.5639 28.1955Z"
        fill="white"
      />
      <path
        d="M16.5635 20.8778L23.9555 16.5858L16.5635 13.2847V20.8778Z"
        fill="white"
        fill-opacity="0.2"
      />
      <path
        d="M9.1709 16.5858L16.5639 20.8778V13.2847L9.1709 16.5858Z"
        fill="white"
        fill-opacity="0.602"
      />
    </g>
    <defs>
      <clipPath id="clip0_355_6008">
        <rect
          width="31.5517"
          height="31.5517"
          fill="white"
          transform="translate(0.296875 0.592773)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'h-6 w-6'
    }
  }
}
</script>
